import gql from 'graphql-tag';

export const REGIST_COMPANION = gql`
    mutation(
        $CompanionList: [CompanionList]
    ){
        RegistCompanion(
            RegistCompanionList: $CompanionList
        ){
            result
        }
    }
`;

export const REGIST_COMPANION_MAIL_SEND = gql`
    mutation(
        $CompanionList: [CompanionList]
        $ReserveEmail: [ReserveEmail]
        $reserveNo: String
        $editFlag: Int
    ){
        RegistCompanionMailSend(
            RegistCompanionList: $CompanionList
            ReserveEmail: $ReserveEmail
            reserveNo: $reserveNo
            editFlag: $editFlag
            send_admin_email: true
        ){
            result
        }
    }
`;

export const GET_COMPANION_LIST = gql`
    query(
        $cell_id: String
        $reserve_no: String
        ){
        GetCompanionList(
            cell_id: $cell_id
            reserve_no: $reserve_no
            ){
            CompanionLists{
                reserve_no
                class_no
                player_no
                cell_id
                member_no
                family_name
                given_name
                nickname
                email
                mobile_number
                gender
                era
                score_level
                profile
                enthusiasm
                member_class
                visited_code
                player_num
                companion_id
            }
            ClassList{
                course_name
                play_start
                class_no
                cell_id
                cell_play_number
                send_play_together_email_flag
            }
        }
    }
`;

export const GET_RESERVE_INFO = gql`
    query(
        $reserve_no: String
        ){
        GetReserveInfo(reserve_no: $reserve_no)
        {
            ReserveInfoList{
                course_name
                play_start
                play_number
                cell_id
                cell_play_number
                send_play_together_email_flag
            }
        }
    }
`;

export const GET_RESERVE_COMPANION = gql`
    query(
        $reserve_no: String
        ){
        GetReserveCompanion(reserve_no: $reserve_no)
        {
            ReserveCompanions{
                reserve_no
                cls_player_no
                member_no
                cell_number
                play_number
                reserve_type
                send_play_together_email_flag
                cell_id
                cell_player_number
                course_code
                course_name
                play_date
                play_start
                player_left
                plt_reserve_no
                class_no
                player_no
                plt_member_no
                family_name
                given_name
                nickname
                gender
                email
                mobile_number
                era
                score_level
                profile
                enthusiasm
                member_class
                visited_code
                player_min
                player_max
                plan_id
                play_together_fixed_deadline
                display_course
                companion_id
            }
        }
    }
`;

// プラン詳細確認 （削除予定）
export const GET_PLAN_DETAILED = gql`
  query(
      $plan_id: Int
  ) {
    GetPlanDetailedConfirmation(
        plan_id: $plan_id
    ) {
        PlanDetailsList {
        total_fee
        plan_name
        golf_code
        golf_name
        play_date
        play_start
        round_code
        cart_code
        request_flag
        add_fee_2b_weekday
        add_fee_3b_weekday
        add_fee_2b_weekend
        add_fee_3b_weekend
        guarantee_code
        caddie_flag
        lesson_flag
        meal_flag
        accommodation_flag
        benefit_flag
        course_name
        cancel_detail
        detail
      }
    }
  }
`;

// プレー日で同伴者情報取得
export const GET_COMPANION_LIST_PLAY_DATE = gql`
    query ( $play_date: String! ){
        GetCompanionListPlayDate (
            play_date:  $play_date
        ) {
            cell_id
            Companion {
                reserve_no
                class_no
                player_no
                cell_id
                member_no
                family_name
                given_name
                nickname
                email
                gender
                era
                score_level
                profile
                enthusiasm
                member_class
                visited_code
                companion_id
            }
        }
    }
`;

// 組合せ登録に必要なデータをまとめて取得
export const GET_RESERVE_COMPANION_SHOW_LIST = gql`
    query(
        $reserve_no: String
        $member_no: ID!
    ){
        GetReserveCompanionShowList(
            reserve_no: $reserve_no
            member_no: $member_no
        )
        {
            ReserveCompanions{
                reserve_no
                cls_player_no
                member_no
                cell_number
                play_number
                reserve_type
                send_play_together_email_flag
                cell_id
                cell_player_number
                course_code
                course_name
                play_date
                play_start
                player_left
                plt_reserve_no
                class_no
                player_no
                plt_member_no
                family_name
                given_name
                nickname
                gender
                email
                mobile_number
                era
                score_level
                profile
                enthusiasm
                member_class
                visited_code
                player_min
                player_max
                plan_id
                play_together_fixed_deadline
                display_course
                companion_id
            }
            Profile{
                era
                family_name
                given_name
                nickname
                email
                score_level
                profile
                mobile_number
                gender
            }
            CompanionLists{
                reserve_no
                player_no
                member_no
                player_name
                mobile_number
                email
                friend_flag
                valid_flag
                pts_reserve_no
                gender
                birth_date
                nickname
                era
                score_level
                profile
                enthusiasm
                member_class
                visited_code
                represent_flag
                org_gender
                org_nickname
                org_era
                org_score_level
                org_profile
                companion_id
            }
            reserve_branch_no
            emailDisb
            mobileNumberDisb
            reserveWeb
            playerList
            companionRegist
        }
    }
`;
